import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private http: HttpClient, private _utilService:UtilsService) {}

  changeNewPassword(reqBody) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.changeNewPassword);
      return this._utilService.putAPICall(url, reqBody, this._utilService.setHeaders())
    } catch (error) {
      console.error('An unexpected error occurred in changeNewPassword:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }
}
